import styles from "./styles.module.css"
import { useState } from "react";
import InputText from "../../Form/InputText";
import InputTextArea from "../../Form/InputTextArea";

import { database } from "../../../services/firebase-config";

import { addDoc, updateDoc, doc } from "firebase/firestore";
import Loading from "../../Loading";


export default function ModalCreateUpdateQuestion({ setModal, collectionRef, questionData, update, updateTableData }) {

    const [question, setQuestion] = useState(questionData ? questionData.question ? questionData.question : '' : '');
    const [answer, setAnswer] = useState(questionData ? questionData.answer ? questionData.answer : '' : '');
    const [isLoading, setIsLoading] = useState(false)

    async function updateQuestion(event) {
        event.preventDefault();
        setIsLoading(true);



        const docRef = doc(database, 'common_questions', questionData.id);
        updateDoc(docRef, {
            question: question,
            answer: answer
        })

        setModal(false)
        setIsLoading(false);

        updateTableData();

    }


    async function createQuestion(event) {
        event.preventDefault();
        setIsLoading(true);
        const newDoc = await addDoc(collectionRef, {
            answer: answer,
            deleted: false,
            question: question,
        });
        updateDoc(newDoc, { id: newDoc.id })

        setModal(false);
        setIsLoading(false);

        updateTableData();
    }

    return (
        <div className={styles.fixed}>
            <div className={styles.modalContainer}>
                <div className={styles.modalCard}>
                    {isLoading && <Loading />}
                    <h2>{update ? 'Atualizar Pergunta' : 'Criar Pergunta'}</h2>

                    <form>
                        <InputText value={question} name="Pergunta" setValue={setQuestion} type="text" />
                        <InputTextArea name='Resposta' value={answer} setValue={setAnswer} />
                    </form>

                    <div className={styles.buttonsContainer}>
                        <button className={styles.modalCard__closeButton} onClick={() => { setModal(false) }}>Fechar</button>
                        {
                            update
                                ?
                                <button onClick={(event) => { updateQuestion(event) }} className={styles.modalCard__saveButton}>Atualizar</button>
                                :
                                <button onClick={(event) => { createQuestion(event) }} className={styles.modalCard__saveButton}>Criar</button>
                        }

                    </div>
                </div>
            </div>
        </div>
    );
}